export const ADD_TO_CHART = "ADD_TO_CHART";
export const REMOVE_FROM_CHART = "REMOVE_FROM_CHART";
export const INCREASE_QUANTITY = "INCREASE_QUANTITY";
export const REDUCE_ITEMS_QUANTITY = "REDUCE_ITEMS_QUANTITY";
export const PURCHASE_ITEM = "PURCHASE_ITEM";
